import { Card, Row, Col, Button, Form } from "react-bootstrap";
import InputFields from "../../shared/utilities/InputFields";
import states from "../../shared/data/States";

export default function MailingSection(props) {
  const copyAddress = (fromType, toType) => {
    if (fromType === "location") {
      props.setFieldValue([toType + "Street1"], props.values.locationStreet1);
      props.setFieldValue([toType + "Street2"], props.values.locationStreet2);
      props.setFieldValue([toType + "State"], props.values.locationState);
      props.setFieldValue([toType + "City"], props.values.locationCity);
      props.setFieldValue([toType + "Zip"], props.values.locationZip);
    }
  };

  return (
    <Card style={{ minHeight: "625px" }} className="tempid-card">
      <Card.Header>
        <i className="fa fa-align-justify"></i>
        <strong>Mailing</strong>
        <div className="card-header-actions"></div>
      </Card.Header>
      <Card.Body>
        <Row className="px-1">
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="mailingAttention"
            config={{
              label: "Attention",
              placeholder: "",
              type: "text",
              col: "xs",
              colWidth: "12",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
        </Row>
        {props.readOnly === false ? (
          <Row className="px-1">
            <Col xs="12" className="p-2">
              <Form.Label
                htmlFor="mailing-sameas-checkbox"
                style={{ marginRight: "20px" }}
              >
                Copy from
              </Form.Label>
              <Button onClick={() => copyAddress("location", "mailing")}>
                Location
              </Button>
            </Col>
          </Row>
        ) : null}
        <Row className="px-1">
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="mailingStreet1"
            config={{
              label: "Street1",
              placeholder: "",
              type: "text"
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
        </Row>
        <Row className="px-1">
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="mailingStreet2"
            config={{
              label: "Street2",
              placeholder: "",
              type: "text",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
        </Row>
        <Row className="px-1">
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="mailingCity"
            config={{
              label: "City",
              placeholder: "",
              type: "text",
              col: "xs",
              colWidth: "4",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="mailingState"
            config={{
              label: "State",
              placeholder: "",
              type: "select2",
              data: states,
              col: "xs",
              colWidth: "4",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="mailingZip"
            config={{
              label: "Zip",
              placeholder: "",
              type: "text",
              col: "xs",
              colWidth: "4",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
        </Row>
      </Card.Body>
    </Card>
  );
}
